export const brand = "var(--seed-color-stroke-brand)";
export const control = "var(--seed-color-stroke-control)";
export const critical = "var(--seed-color-stroke-critical)";
export const field = "var(--seed-color-stroke-field)";
export const informative = "var(--seed-color-stroke-informative)";
export const neutral = "var(--seed-color-stroke-neutral)";
export const positive = "var(--seed-color-stroke-positive)";
export const fieldFocused = "var(--seed-color-stroke-field-focused)";
export const neutralMuted = "var(--seed-color-stroke-neutral-muted)";
export const onImage = "var(--seed-color-stroke-on-image)";